module.exports = __webpack_public_path__ + "_assets/img/close-icon.7be246d4.svg";